import { BANNER_TRIGGER_UNDO_REDO } from '../banner/bannerActions';
import { trackedActions } from '../banner/bannerFilteredActions';

export const filter = (action, currentState, previousHistory) => {
  if (previousHistory._latestUnfiltered && action.type === BANNER_TRIGGER_UNDO_REDO) return false;
  return trackedActions.includes(action.type) && !action.untrack && action.fromMasterBanner;
};
